export var EventStatus;
(function (EventStatus) {
    EventStatus["GPP_LOADED"] = "gpploaded";
    EventStatus["CMP_UI_SHOWN"] = "cmpuishown";
    EventStatus["USER_ACTION_COMPLETE"] = "useractioncomplete";
})(EventStatus || (EventStatus = {}));
